<template>
	<div>
		<!-- dialog -->
		<v-dialog v-model="dialog" max-width="400">
			<v-form ref="form" @submit.prevent="submit">
				<v-card>
					<v-card-title class="primary--text">
						<v-btn icon @click="dialog = false">
							<v-icon>mdi-close</v-icon>
						</v-btn>
				
						<v-spacer/>
						<span class="me-8">
							{{ !messageId ? $t('QuickMessages.add-message') : $t('QuickMessages.edit-message')}}
						</span>
						<v-spacer/>
					</v-card-title>
					<v-card-text class="pb-2">
						<v-textarea
							v-model="message"
							label="الرسالة"
							rows="2"
							dense
							outlined
							rounded
							auto-grow
							hide-details
							:rules="rules.required"
						/>
					</v-card-text>
					<v-card-actions class="justify-end">
						<v-btn
							type="submit"
							color="primary"
							:loading="submitLoading"
						>
							{{$t('save')}}
						</v-btn>
						<v-btn @click="dialog = false">
							{{$t('cancel')}}
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-form>
		</v-dialog>

		<!-- delete dialog -->
		<v-dialog v-model="deleteDialog" max-width="300">
			<v-form @submit.prevent="deleteMessage">
				<v-card>
					<v-card-title class="error--text">
						<v-btn icon @click="deleteDialog = false">
							<v-icon>mdi-close</v-icon>
						</v-btn>
				
						<v-spacer/>
						<span class="me-8">
							حذف الرسالة
						</span>
						<v-spacer/>
					</v-card-title>
					<v-card-text class="pb-2">
						هل انت متأكد من حذف الرسالة؟
					</v-card-text>
					<v-card-actions class="justify-end">
						<v-btn
							type="submit"
							color="error"
							:loading="deleteLoading"
						>
							{{$t('delete')}}
						</v-btn>
						<v-btn @click="deleteDialog = false">
							{{$t('cancel')}}
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-form>
		</v-dialog>

		<!-- add -->
		<div class="text-end mb-2">
			<v-btn color="primary" @click="dialog = true">
				{{$t('QuickMessages.add-message')}}
			</v-btn>
		</div>

		<!-- table -->
		<v-data-table
			:headers="headers"
			:items="!loading ? quickMessages : []"
			:loading="loading"
			:items-per-page="50"
			dense
			:footer-props="{
				'items-per-page-options': [20, 50, 100, -1],
			}"
			:height="$vuetify.breakpoint.height - 190"
			class="elevation-2"
			disable-sort
		>
			<template v-slot:item.actions="{ item }">
				<div class="d-flex">
					<!-- edit -->
					<v-tooltip top>
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								depressed
								height="30"
								width="30"
								min-width="30"
								class="my-1"
								color="purple lighten-4 primary--text"
								v-on="on"
								v-bind="attrs"
								@click="messageId = item.ID; dialog = true;"
							>
								<v-icon>mdi-pencil</v-icon>
							</v-btn>
						</template>
					
						{{$t('edit')}}
					</v-tooltip>
					
					<!-- delete -->
					<v-tooltip top>
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								depressed
								height="30"
								width="30"
								min-width="30"
								class="my-1"
								color="error lighten-4 error--text ms-1"
								v-on="on"
								v-bind="attrs"
								@click="deleteId = item.ID; deleteDialog = true;"
							>
								<v-icon>mdi-delete</v-icon>
							</v-btn>
						</template>
					
						{{$t('delete')}}
					</v-tooltip>
				</div>
			</template>
		</v-data-table>
	</div>
</template>

<script>
import rules from '@/helpers/validation rules';
import { mapGetters, mapState } from 'vuex';
export default {
	name: 'QuickMessages',

	data() {
		return {
			rules,

			dialog: false,
			loading: false,

			deleteDialog: false,
			deleteId: null,
			deleteLoading: false,

			submitLoading: false,

			// data
			messageId: null,
			message: null,
		}
	},

	watch: {
		dialog(val) {
			if (val) {
				if (this.messageId) {
					this.message = this.getQuickMessageById(this.messageId)?.Message;
				}
			} else {
				this.$refs.form.reset();
				this.messageId = null;
			}
		}
	},

	computed: {
		...mapState({
			quickMessages: state => state.quickMessages.quickMessages,
		}),

		...mapGetters({
			getQuickMessageById: 'quickMessages/getQuickMessageById'
		}),

		headers() {
			return [
				{
					text: this.$t('headers.message'),
					value: 'Message',
				},
				{
					text: '',
					value: 'actions',
					width: 40
				},
			]
		}
	},

	methods: {
		fetchQuickMessages() {
			this.loading = true;
			this.$store.dispatch('quickMessages/fetchAll').then(() => {
				this.loading = false;
			});
		},
		
		submit() {
			if (this.$refs.form.validate()) {
				this.submitLoading = true;
				const actionName = !this.messageId ? 'create' : 'update';
				this.$store.dispatch(`quickMessages/${actionName}`, {
					id: this.messageId,
					message: this.message,
				}).then(() => {
					this.dialog = false;
					this.$eventBus.$emit('show-snackbar', 'info', this.$t('messages.saved-successfully'))
					this.fetchQuickMessages();
				}).finally(() => {
					this.submitLoading = false;
				});
			}
		},

		deleteMessage() {
			this.deleteLoading = true;
			this.$store.dispatch('quickMessages/delete', { id: this.deleteId }).then(() => {
				this.deleteDialog = false;
				this.$eventBus.$emit('show-snackbar', 'info', this.$t('messages.deleted-successfully'))
				this.fetchQuickMessages();
			}).finally(() => {
				this.deleteLoading = false;
			});
		}
	},

	created() {
		if (!this.quickMessages.length) {
			this.fetchQuickMessages();
		}
	}
};
</script>

<style>
</style>